export default function About() {
  return (
    <div className="about container">
      <h2>
      Over 10 years of digital marketing and e-commerce experience, I specialize in creating unique storefronts and digital-first strategies that drive conversions.</h2>
    </div>
  );
}
